class ProductsAPI {
  static all(state) {
    let url = this.getUrl(state)

    return fetch(url, {
      credentials: 'same-origin'
    }).then(this.handleStatus)
  }

  static handleStatus(response) {
    if (!response.ok) {
      // Fetch doesn't reject on HTTP error status
      throw Error(`Request rejected with status ${response.status}`)
    }
    return response
  }

  static getUrl(params) {
    let { currentCategories, currentColors, currentWidths, order, count, offset } = params;

    let orderby = this.orderQuery(order)

    const filterCategories = currentCategories.length > 0 ? `&vorm=${currentCategories}` : '';
    const filterColors = currentColors.length > 0 ? `&kleur=${currentColors}` : '';
    const filterWidths = currentWidths.length > 0 ? `&dikte=${currentWidths}` : '';

    let query = filterCategories + filterColors + filterWidths;
    let countQuery = `per_page=${count}`

    return `/wp-json/wp/v2/product?${countQuery}${orderby}${query}`;
  }

  static orderQuery(order) {
    if (order === 'price_desc') {
      return '?orderby=price&order=desc'
    } else if (order === 'price_asc') {
      return '?orderby=price&order=asc'
    } else {
      return ''
    }
  }
}

export default ProductsAPI;


// WEBPACK FOOTER //
// ./src/js/shop-overview/api/ProductsAPI.js